"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePicker = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));
var _format = require("../../../utils/dates/format");
var _classnames = _interopRequireDefault(require("classnames"));
var _DateInput = require("./date-input/DateInput");
require("react-datepicker/dist/react-datepicker.css");
var _datePickerModule = _interopRequireDefault(require("./date-picker.module.scss"));
var _enGB = _interopRequireDefault(require("date-fns/locale/en-GB"));
var _dateFns = require("date-fns");
var _Preset = require("./preset/Preset");
var _CalendarHeader = require("../calendar-header/CalendarHeader");
var _useTranslation2 = require("../../../hooks/useTranslation/useTranslation");
(0, _reactDatepicker.registerLocale)('en', _enGB.default);
var DatePicker = function DatePicker(_ref) {
  var _classNames;
  var value = _ref.value,
    onChange = _ref.onChange,
    id = _ref.id,
    placeholder = _ref.placeholder,
    className = _ref.className,
    disabled = _ref.disabled,
    error = _ref.error,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'bottom' : _ref$position,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'normal' : _ref$size,
    excludeDates = _ref.excludeDates;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var inputRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(value ? value : undefined),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    selectedDate = _useState4[0],
    setSelectedDate = _useState4[1];
  var renderDay = function renderDay(day, date) {
    return /*#__PURE__*/_react.default.createElement("span", {
      "data-testid": (0, _format.formatIsoDate)(date),
      className: _datePickerModule.default['date-picker__day']
    }, (0, _dateFns.getDate)(date));
  };
  var renderContainer = function renderContainer(_ref2) {
    var children = _ref2.children;
    var handleChange = function handleChange(date) {
      handleOnChange(date);
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": 'date-picker-container',
      className: _datePickerModule.default['date-picker__container']
    }, children, /*#__PURE__*/_react.default.createElement(_Preset.Preset, {
      onChange: handleChange,
      date: selectedDate,
      excludeDates: excludeDates
    }));
  };
  var closeCalendar = function closeCalendar() {
    setIsOpen(false);
  };
  var openCalendar = function openCalendar() {
    setIsOpen(true);
  };
  var handleOnChange = function handleOnChange(date) {
    var newDate = date ? date : undefined;
    onChange(newDate);
    setSelectedDate(newDate);
    closeCalendar();
  };
  var handleIconClick = function handleIconClick() {
    var calendar = document.querySelector('[data-testid="date-picker-container"]');
    if (calendar) {
      closeCalendar();
    } else {
      openCalendar();
      inputRef.current.focus();
    }
  };
  var _onClickOutside = function onClickOutside() {
    closeCalendar();
  };
  var onClearClick = function onClearClick() {
    closeCalendar();
  };
  var filterDates = function filterDates(date) {
    if (excludeDates) {
      return !excludeDates(date);
    } else {
      return true;
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_datePickerModule.default['date-picker'], className, (_classNames = {}, (0, _defineProperty2.default)(_classNames, _datePickerModule.default['date-picker--disabled'], disabled), (0, _defineProperty2.default)(_classNames, _datePickerModule.default['date-picker--error'], error), (0, _defineProperty2.default)(_classNames, _datePickerModule.default['date-picker--top'], position === 'top'), (0, _defineProperty2.default)(_classNames, _datePickerModule.default['date-picker--small'], size === 'small'), _classNames))
  }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, {
    id: id,
    open: isOpen,
    locale: "en",
    autocomplete: false,
    selected: selectedDate,
    onChange: handleOnChange,
    dateFormat: _format.shortDateFormat,
    placeholderText:
    // @ts-ignore-next
    placeholder ? placeholder : t('date.placeholder'),
    showPopperArrow: false,
    renderDayContents: renderDay,
    filterDate: filterDates,
    renderCustomHeader: _CalendarHeader.CustomHeader,
    calendarContainer: renderContainer,
    onClickOutside: function onClickOutside() {
      return _onClickOutside();
    },
    onInputClick: function onInputClick() {
      return openCalendar();
    },
    customInputRef: 'customRef',
    customInput: /*#__PURE__*/_react.default.createElement(_DateInput.DateInput, {
      id: id,
      name: id,
      ref: inputRef,
      error: error,
      onIconClick: handleIconClick,
      onClearClick: onClearClick
    }),
    disabled: disabled
  }));
};
exports.DatePicker = DatePicker;